import React from 'react'
import { StyledFirstForm } from './styled'
import { API } from 'javascripts/api'
import { FormProvider, useForm } from 'react-hook-form'
import { WorkPreference, WorkPreferenceFormFormGroupEnum  } from 'javascripts/api/generated'
import { useConfirmationBeforeUnload } from '../hooks/useConfirmationBeforeUnload'
import { WorkPreferenceFormNames } from '../../constants'
import { FirstFormProps } from './types'
import { useAtom } from 'jotai'
import { stateAtom } from 'spa/member/atoms/WorkPreference/stateAtom'

export const FirstForm: React.FC<FirstFormProps> = (props: FirstFormProps) => {
  const [_state, setState] = useAtom(stateAtom)

  const { ...method } = useForm({
    mode: 'onChange',
    defaultValues: async () => {
      const response = await API.getWorkPreference()
      const json: WorkPreference | null = response.data

      const WEEKDAYS = ['0', '1', '2', '3', '4', '5', '6']
      const workDaysAllSelected = WEEKDAYS.every(day =>
        json?.work_days_of_week?.includes(Number(day)) ?? false
      )
      const officeDaysAllSelected = WEEKDAYS.every(day =>
        json?.office_days_of_week?.includes(Number(day)) ?? false
      )

      return {
        start_date: json?.start_date,
        min_work_hours_per_week: json?.min_work_hours_per_week,
        max_work_hours_per_week: json?.max_work_hours_per_week,
        _min_work_hours_per_month: json?.min_work_hours_per_week * 4,
        _max_work_hours_per_month: json?.max_work_hours_per_week * 4,
        work_days_of_week: workDaysAllSelected
          ? ['all', ...json.work_days_of_week.map(val => val.toString())]
          : json?.work_days_of_week?.map(val => val.toString()),
        office_days_of_week: json?.office_days_of_week?.length === 0
          ? ['7']
          : officeDaysAllSelected
          ? ['all', ...json.office_days_of_week.map(val => val.toString())]
          : json?.office_days_of_week?.map(val => val.toString()),
        remote_work_preference: json?.remote_work_preference,
        available_time: json?.available_time,
      }
    },
  })

  useConfirmationBeforeUnload(props.formType, method.formState.isDirty)

  const onSubmit = async (data) => {
    setState(prev => ({...prev, sending: true }))

    const {
      _max_work_hours_per_month,
      _min_work_hours_per_month,
      _desired_hourly_salary,
      ...sendData
    } = data

    const formattedData = {
      ...sendData,
      work_days_of_week: sendData.work_days_of_week
        .filter(day => day !== 'all')
        .map(Number),
      office_days_of_week: sendData.office_days_of_week.length === 1 &&
      sendData.office_days_of_week[0] === '7'
        ? []
        : sendData.office_days_of_week
          .filter(day => day !== 'all')
          .map(Number),
      min_work_hours_per_week: Number(sendData.min_work_hours_per_week),
      max_work_hours_per_week: Number(sendData.max_work_hours_per_week),
      form_group: WorkPreferenceFormFormGroupEnum.CurrentSituation,
    }

    try {
      await API.updateWorkPreference(formattedData)
    } catch (error) {
      window.alert('エラーが発生しました。')
      return
    } finally {
      setState(prev => ({...prev, sending: false }))
    }

    // defaultValuesを再設定して、isDirtyの値をリセットする
    method.reset(data)

    props.onChangeStep('next')
  }

  return (
    <FormProvider {...method}>
      <form id={WorkPreferenceFormNames.CurrentSituation} onSubmit={method.handleSubmit(onSubmit)} noValidate>
        <StyledFirstForm formType={props.formType} />
      </form>
    </FormProvider>
  )
}
